import "@/shared/libs/jquery-widget-factory";
import registerSelectboxIt from "@/shared/libs/selectboxit.js";
import $ from "jquery";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";

const selectboxitOptions = {
    isMobile: ResponsiveUtils.isMobile,
};

export function registerSelectBoxIt() {
    registerSelectboxIt($, window, document);
}
export function useSelectBoxIt() {
    const elements = $("select:not(.no-selectboxit)");
    elements.selectBoxIt(selectboxitOptions);
    if (!ResponsiveUtils.isMobile()) {
        addSupportForNativeEventListener(elements);
    }
}

export const initSelectBoxIt = (elem: HTMLElement | JQuery) => {
    const e = $(elem);
    e.selectBoxIt(selectboxitOptions);
    if (!ResponsiveUtils.isMobile()) {
        addSupportForNativeEventListener(e);
    }
};

export const refreshSelectBox = (element: JQuery) => {
    if (element && element.length) {
        for (let i = 0; i < element.length; i++) {
            const data = element.eq(i).data("selectBox-selectBoxIt");

            if (data) {
                const selectOptions = (element[i] as HTMLSelectElement).options;
                const changed =
                    data.currentFocus != (element[i] as HTMLSelectElement).selectedIndex ||
                    selectOptions.length != data.textArray.length ||
                    !Array.prototype.every.call(selectOptions, (option, index) => option.text == data.textArray[index]);

                if (changed) data.refresh();

                //data.selectOption(element.val()); // triggers change
            }
        }
    }
};

function addSupportForNativeEventListener(elements: JQuery<HTMLElement>) {
    elements.on(
        "change",
        (function () {
            let value = null;
            return function (event) {
                const target: any = event.target;
                if (value !== target.value) {
                    value = target.value;

                    if (typeof Event === "function") {
                        target.dispatchEvent(new Event("change"));
                    } else {
                        const newEvent = document.createEvent("Event");
                        newEvent.initEvent("change", true, true);
                        target.dispatchEvent(newEvent);
                    }
                }
            };
        })()
    );
}
